import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'

export default combineReducers({
  byId: createByIdReducer('user'),
  allIds: createAllIdsReducer('user'),
  indexIds: createIndexIdsReducer('user'),
  meta: createMetaReducer('user'),
})

// SELECTORS

export const selectUser = (state, id) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}

export const selectUserIndex = (state) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectAllUsers = (state) => {
  return state.allIds.map((id) => state.byId[id]) || []
}

export const selectUserMeta = (state) => {
  return state.meta || {}
}
